import { useState } from "react";
import axios from "axios";

// hooks and utilities
import { useLanguage, useTranslateFunction } from "lang/Translate";

// common components
import SlidingTextButton from "components/common/SlidingTextButton/SlidingTextButton";

// api
import api from "api/api";

// styles
import "./ResetPassword.scoped.scss";

const ResetPassword = ({ setPending }) => {
	const [email, setEmail] = useState("");

	const translate = useTranslateFunction("ResetPassword");
	const lang = useLanguage();

	async function sendResetLink() {
		setPending(true);
		const searchParams = new URLSearchParams(window.location.search);

		try {
			const { data } = await axios.post(
				`${api}/auth/password/code`,
				{ email, lang },
				{ headers: { "content-type": "application/x-www-form-urlencoded" } }
			);
			if (data.error) {
				searchParams.set("causeEn", data.error);
				searchParams.set("causePL", data.errorEn);
				throw new Error(data.errorEn);
			}

			searchParams.set("type", "resetPasswordPending");
		} catch (err) {
			console.error(err);

			searchParams.set("causeEn", "An error has occurred. Please try again.");
			searchParams.set("causePL", "Wystąpił błąd. Spróbój ponownie.");
			searchParams.set("type", "resetPasswordError");
		}

		window.location.search = searchParams.toString();
	}

	return (
		<>
			<h2>{translate("RESET_PASSWORD")}</h2>
			<form action="">
				<div className="input">
					<div className="icon">
						<i className="fas fa-envelope" aria-hidden="true" />
					</div>
					<input
						type="email"
						placeholder={translate("EMAIL_ADDRESS")}
						autoComplete="email"
						value={email}
						onChange={e => setEmail(e.target.value)}
					/>
				</div>

				<SlidingTextButton
					icon={<i className="fas fa-envelope-open-text" />}
					text={translate("SEND_RESET_LINK")}
					background="darkBlue"
					onClick={sendResetLink}
				/>
			</form>
		</>
	);
};

const ResetPasswordPending = () => {
	const translate = useTranslateFunction("ResetPassword");

	const searchParams = new URLSearchParams(window.location.search);
	const email = searchParams.get("email");

	return (
		<>
			<h2>{translate("PENDING_HEADER")}</h2>
			<p>
				{translate("PENDING_CONTENT").split("%")[0]} <b>{email}</b>
				{translate("PENDING_CONTENT").split("%")[1]}
			</p>
		</>
	);
};

const ResetPasswordError = () => {
	const searchParams = new URLSearchParams(window.location.search);
	const causePl = searchParams.get("causePL");
	const causeEn = searchParams.get("causeEn");

	const translate = useTranslateFunction("ResetPassword");
	const lang = useLanguage();

	return (
		<>
			<h2>{translate("ERROR_HEADER")}</h2>
			<p>{lang === "PL" ? causePl : causeEn}</p>
		</>
	);
};

const ResetPasswordSuccess = () => {
	const translate = useTranslateFunction("ResetPassword");

	return (
		<>
			<h2 style={{ color: "hsl(168, 97%, 31%)" }}>{translate("SUCCESS_HEADER")}</h2>
			<p style={{ color: "hsl(168, 97%, 31%)" }}>{translate("SUCCESS_CONTENT")}</p>
		</>
	);
};

const NewPassword = ({ setPending }) => {
	const [password, setPassword] = useState("");
	const [repeatPassword, setRepeatPassword] = useState("");
	const [errors, setErrors] = useState([]);

	const searchParams = new URLSearchParams(window.location.search);
	const email = searchParams.get("email");
	const code = searchParams.get("code");

	const translate = useTranslateFunction("ResetPassword");
	const lang = useLanguage();

	async function submit() {
		setErrors([]);
		setPending(true);

		const searchParams = new URLSearchParams(window.location.search);

		try {
			await axios.patch(`${api}/auth/password`, { password, repeatPassword, email, code });
			searchParams.set("type", "resetPasswordSuccess");
		} catch (err) {
			if (err.response.status === 422) {
				setErrors(err.response.data);
				return;
			}

			console.error(err);
			searchParams.set("type", "resetPasswordError");
		} finally {
			setPending(false);
		}

		// window.location.search = searchParams.toString();
	}

	return (
		<>
			<h2>{translate("NEW_PASSWORD_HEADER")}</h2>
			<form action="">
				<div className="input">
					<div className="icon">
						<i className="fas fa-key" aria-hidden="true" />
					</div>
					<input
						type="password"
						placeholder={translate("NEW_PASSWORD")}
						autoComplete="new-password"
						value={password}
						onChange={e => setPassword(e.target.value)}
					/>
				</div>

				<div className="input">
					<div className="icon">
						<i className="fas fa-key" aria-hidden="true" />
					</div>
					<input
						type="password"
						placeholder={translate("REPEAT_PASSWORD")}
						autoComplete="off"
						value={repeatPassword}
						onChange={e => setRepeatPassword(e.target.value)}
					/>
				</div>
			</form>

			{errors.length > 0 && (
				<div className="errors">
					{errors.map((e, i) => (
						<p className="pass_err" key={i}>
							{lang === "PL" ? e.error : e.errorEn || e.error}!
						</p>
					))}
				</div>
			)}

			<form action="">
				<SlidingTextButton
					icon={<i className="fas fa-check" />}
					text={translate("SET_NEW_PASSWORD")}
					background="darkBlue"
					onClick={submit}
				/>
			</form>
		</>
	);
};

export { ResetPassword, ResetPasswordPending, ResetPasswordError, NewPassword, ResetPasswordSuccess };
